import { render, staticRenderFns } from "./ComponenteSOS.vue?vue&type=template&id=1dec1333&scoped=true&"
import script from "./ComponenteSOS.vue?vue&type=script&lang=js&"
export * from "./ComponenteSOS.vue?vue&type=script&lang=js&"
import style0 from "./ComponenteSOS.vue?vue&type=style&index=0&id=1dec1333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec1333",
  null
  
)

export default component.exports